module.exports = __webpack_public_path__ + "img/fundo_de_olho.bc89119e.svg";